import { wave } from '../motifs';
import { M } from '../palette';
import { registerPlate } from '../registry';

const WATER = ['#7ac0f0', '#2e78c0', '#174a86'] as const;

/** 17 สายน้ำ: the stream plate, deep navy lacquer between two breaking blue waves. */
registerPlate({
  id: 'stream',
  name: 'สายน้ำ',
  ground: ['#2a4c78', '#16304e', '#0e2036'],
  trim: '#7ab0e0',
  text: { fill: ['#f0f8ff', '#b8dcf8'], line: '#06101e' },
  inset: [17, 17],
  tassels: [{ x: 3, charm: 'bead', charmTones: ['#d0ecff', '#6ab0e8', '#2a6aa8'] }, { x: -4 }],
  front(p, f) {
    wave(p, f.x - 11, f.b + 5, 27, 28, WATER);
    wave(p, f.r - 16, f.b + 5, 27, 25, WATER, true);
  },
  motion: {
    sprites: {
      spray: {
        w: 4,
        h: 3,
        draw: (p) => p.px(0, 2, M.whiteHi).px(1, 0, '#ffffff').px(3, 1, M.whiteHi).px(2, 2, '#d8eeff'),
      },
    },
    play(a, t, f) {
      // Spray thrown off the crests, rising and falling with the swell.
      const bob = (k: number) => Math.round(Math.sin(t * 2.4 + k) * 1.5);
      a.spr('spray', f.x + 5, f.y - 12 + bob(0), 0.5 + 0.5 * Math.sin(t * 3));
      a.spr('spray', f.r - 9, f.y - 10 + bob(2), 0.5 + 0.5 * Math.sin(t * 3 + 2));
      a.spr('spray', f.x + 9, f.y - 8 + bob(4), 0.5 + 0.5 * Math.sin(t * 3 + 4));
    },
  },
});
